module.exports = __webpack_public_path__ + "static/media/frame_01.9bcbbec8.png";